import { Link, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import x from "../../../assets/images/X.png";
import refermodal from "../../../assets/images/ReferalProgram/refermodal.webp";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  convertGlobalPrice,
  updateReferalinUser,
} from "../../../utils/firebase/firebase.utils";
import { useContext } from "react";
import { UserContext } from "../../../context/user.context";

function ReferalModal({ show, setShow }) {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const { updateReferral } = useSelector((store) => store.flags);
  function UpdateReferal(c) {
    const user = currentUser;

    if (user?.referralDismiss == undefined) {
      var list = [false, false, false, false];
    } else {
      var list = user?.referralDismiss.map((e) => e);
    }
    try {
      if (user != null) {
        console.log(user?.referralDismiss);

        if (list?.length > 0) {
          list[c] = true;
        }
        if (c === 3) {
          if (list[2] === false) {
            list[2] = true;
          }
          if (list[1] === false) {
            list[1] = true;
          }
          if (list[0] === false) {
            list[0] = true;
          }
        } else if (c === 2) {
          if (list[1] === false) {
            list[1] = true;
          }
          if (list[0] === false) {
            list[0] = true;
          }
        } else if (c === 1) {
          if (list[0] === false) {
            list[0] = true;
          }
        }

        if (currentUser) {
          updateReferalinUser(
            currentUser?.uid,
            list?.map((e) => e)
          );
        }
      }
    } catch (error) {
      // Handle error if needed
    }
  }
  return (
    <>
      <Modal
        // className="modal fade"
        // id="SignUp"
        // tabIndex="-1"
        // role="dialog"
        // aria-labelledby="SignUp"
        show={show}
        className="modal fade referalModal"
        centered
      >
        {/* <div
          className="modal-dialog modal-dialog-centered modal-signup"
          role="document"
        > */}
        <Modal.Body className="p-0 m-0 ">
          <div className="w-100">
            <img src={refermodal} className="img-fluid w-100" alt="Image" />
            <div className="text-overlayxx ">
              <div>
                <button
                  type="button"
                  className="close close-txt close-modal align-items-center px-0"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setShow(false) & UpdateReferal(updateReferral)}
                >
                  <img
                    src={x}
                    onClick={() =>
                      setShow(false) & UpdateReferal(updateReferral)
                    }
                    className="x-close"
                    alt="main"
                  />

                  {/* <img src={closeModal} onClick={()=>setShow(false)} className="ms-1 mb-1 close-btn2"/> */}
                </button>
              </div>
            </div>
          </div>

          <div className="modal-body px-0 mt-md-1 mt-2 mb-1">
            <div className="refralmodaltitle">{t("REFER YOUR FRIENDS")}</div>
            <div className="w-100 justify-content-center d-flex pt-4 pb-4 pt-md-3 pb-md-3">
              <div className="refralmodalsubtitle">
                {t("AND GET LIBAS CREDIT")}
              </div>
            </div>
            <div className="justify-content-center d-flex w-100 text-center">
              <div
                className="justify-content-center d-flex btn-refer"
                onClick={() =>
                  navigate("/referral-program-Libas") &
                  UpdateReferal(updateReferral) &
                  setShow(false)
                }
              >
                {t("REFER NOW")} !
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReferalModal;
